import Box, { type BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type { ReactNode } from 'react';

export function LoadingPlaceholder({ sx, ...props }: BoxProps) {
  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        position: 'absolute',
        ...sx,
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export function LoadingPlaceholderContainer({
  children,
  isLoading,
  ...props
}: BoxProps & { isLoading: boolean; children: ReactNode }) {
  return isLoading ? <LoadingPlaceholder {...props} /> : children;
}
